export const LED_COLORS = [
  { key: 'cyan', hex: '#22e3ff', name: { fr: 'Cyan', en: 'Cyan', ar: 'سماوي', it: 'Ciano' } },
  { key: 'blue', hex: '#2d6bff', name: { fr: 'Bleu', en: 'Blue', ar: 'أزرق', it: 'Blu' } },
  { key: 'violet', hex: '#8b3cff', name: { fr: 'Violet', en: 'Violet', ar: 'بنفسجي', it: 'Viola' } },
  { key: 'magenta', hex: '#ff2fd0', name: { fr: 'Magenta', en: 'Magenta', ar: 'أرجواني', it: 'Magenta' } },
  { key: 'red', hex: '#ff2d36', name: { fr: 'Rouge', en: 'Red', ar: 'أحمر', it: 'Rosso' } },
  { key: 'orange', hex: '#ff8a1e', name: { fr: 'Orange', en: 'Orange', ar: 'برتقالي', it: 'Arancione' } },
  { key: 'amber', hex: '#ffc61e', name: { fr: 'Ambre', en: 'Amber', ar: 'كهرماني', it: 'Ambra' } },
  { key: 'green', hex: '#2bff7a', name: { fr: 'Vert', en: 'Green', ar: 'أخضر', it: 'Verde' } },
  { key: 'turquoise', hex: '#12ffd0', name: { fr: 'Turquoise', en: 'Turquoise', ar: 'فيروزي', it: 'Turchese' } },
  { key: 'pink', hex: '#ff6fa5', name: { fr: 'Rose', en: 'Pink', ar: 'وردي', it: 'Rosa' } },
  { key: 'white', hex: '#ffffff', name: { fr: 'Blanc', en: 'White', ar: 'أبيض', it: 'Bianco' } },
];

export const LED_MODES = [
  { key: 'solid', name: { fr: 'Fixe', en: 'Solid', ar: 'ثابت', it: 'Fisso' } },
  { key: 'slow', name: { fr: 'Clignotant lent', en: 'Slow flash', ar: 'وميض بطيء', it: 'Lampeggio lento' } },
  { key: 'fast', name: { fr: 'Clignotant rapide', en: 'Fast flash', ar: 'وميض سريع', it: 'Lampeggio rapido' } },
  { key: 'wave', name: { fr: 'Vague', en: 'Wave', ar: 'موجة', it: 'Onda' } },
  { key: 'fade', name: { fr: 'Fondu', en: 'Fade', ar: 'تلاشي', it: 'Dissolvenza' } },
];

export const SIM_LABELS = {
  fr: {
    title: 'Simulateur de couleurs',
    subtitle: 'Choisissez une couleur et un effet : tous les bracelets du kit s\'allument ensemble, exactement comme le soir de votre événement.',
    color: 'Couleur',
    mode: 'Effet lumineux',
    selected: 'Sélection',
    view: 'Affichage', viewFew: '5 bracelets', viewCrowd: 'Foule (50 bracelets)',
    note: 'Rendu indicatif. Les bracelets sont livrés avec 16 couleurs pilotables et se synchronisent automatiquement entre eux.',
  },
  en: {
    title: 'Colour simulator',
    subtitle: 'Pick a colour and an effect: every wristband in the kit lights up together, exactly like on the night of your event.',
    color: 'Colour',
    mode: 'Light effect',
    selected: 'Selection',
    view: 'View', viewFew: '5 wristbands', viewCrowd: 'Crowd (50 wristbands)',
    note: 'Indicative preview. The wristbands ship with 16 controllable colours and synchronise automatically with each other.',
  },
  ar: {
    title: 'محاكي الألوان',
    subtitle: 'اختر لونًا وتأثيرًا: تضيء جميع الأسورة في الطقم معًا، تمامًا كما في ليلة حدثك.',
    color: 'اللون',
    mode: 'التأثير الضوئي',
    selected: 'الاختيار',
    view: 'العرض', viewFew: '5 أسورة', viewCrowd: 'حشد (50 سوارًا)',
    note: 'معاينة توضيحية. تُسلَّم الأسورة مع 16 لونًا قابلاً للتحكم وتتزامن تلقائيًا مع بعضها.',
  },
  it: {
    title: 'Simulatore di colori',
    subtitle: 'Scegli un colore e un effetto: tutti i bracciali del kit si accendono insieme, esattamente come la sera del tuo evento.',
    color: 'Colore',
    mode: 'Effetto luminoso',
    selected: 'Selezione',
    view: 'Visualizzazione', viewFew: '5 bracciali', viewCrowd: 'Folla (50 bracciali)',
    note: 'Resa indicativa. I bracciali vengono forniti con 16 colori pilotabili e si sincronizzano automaticamente tra loro.',
  },
};
